import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submit-form"
export default class extends Controller {
  static targets = ["form"];
  static values = {
    debounce: { type: Number, default: 300 }
  };

  connect() {
    this.form = this.hasFormTarget ? this.formTarget : this.element;
    $('.datepicker').change(function() {
      const event = new Event('change')
      this.dispatchEvent(event)
    })

    $('input[type=checkbox]').click(function() {
      const event = new Event('change')
      this.dispatchEvent(event)
    })
 }

  submit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.form.requestSubmit();
    }, this.debounceValue);
  }

  showSubmitButton() {
    this.form.querySelectorAll("button, .btn").forEach((button) => {
      button.classList.remove("invisible")
    })
  }
}
